export const enGb = {
  created: "Created",
  approved: "Approved",
  rejectedByUser: "Rejected by user",
  rejectedByProvider: "Rejected by provider",
  processing: "Processing",
  confirmed: "Confirmed",
  failed: "Failed",
  initiated: "Initiated",
  rejection: "Rejection",
  amount: "Amount",
  cannotLoadPayoutsList: "Cannot load payouts list. Please try again later.",
  ccy: "CCY",
  customerName: "Customer name",
  date: "Date",
  payments: "Payments",
  payouts: "Payouts",
  payoutTitle: "Payout title",
  requestedBy: "Requested by",
  status: "Status",
  createANewPayout: "Create a new payout",
  youDontHaveAnyPayoutsCreatedYet: "You don't have any payouts created yet.",
  cannotLoadCustomerNames:
    "Cannot load customer names. Please try again later.",
};
